<button [disabled]="disabled" [class]="getButtonClasses()" (click)="onClick($event)">
  <div class="content-container">
    @if (icon) {
      <fa-icon [icon]="icon" [class.text-hidden]="isLoading"></fa-icon>
    }
    <span [class.text-hidden]="isLoading">{{ text }}</span>
    <!-- TODO spinner color optimized for primary button only -->
    @if (isLoading) {
      <mat-progress-spinner
        class="spinner"
        mode="indeterminate"
        [strokeWidth]="2"
        [diameter]="20"
      ></mat-progress-spinner>
    }
  </div>
</button>
